import { render, staticRenderFns } from "./BottomButton.vue?vue&type=template&id=3e74399f"
import script from "./BottomButton.vue?vue&type=script&lang=js"
export * from "./BottomButton.vue?vue&type=script&lang=js"
import style0 from "./BottomButton.vue?vue&type=style&index=0&id=3e74399f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports